<template>
  <div id="diag-banner">
    <div id="stick-bar" class="row banner-container">
      <div class="col-xs-12 col-sm-6 col-md-8">
        <h2 v-if="bannerText" class="banner-text">{{ bannerText }}</h2>
      </div>
      <div v-if="bannerCtaText" class="col-xs-12 col-sm-6 col-md-4">
        <a :href="bannerCta" class="header-cta-button ripple-animation">{{ bannerCtaText }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'diagnosis-header-banner',
  props: {
    bannerText: {
      type: String,
      required: true,
    },
    bannerCta: {
      type: String,
      required: true,
    },
    bannerCtaText: {
      type: String,
      required: true,
    },
  },
  mounted() {
    document.addEventListener('scroll', this.checkScrollPosition);
  },
  methods: {
    checkScrollPosition() {
      const bannerContainer = document.getElementById('diag-banner');
      const stickbanner = document.getElementById('stick-bar');
      const sticky = bannerContainer.offsetTop;
      if (window.pageYOffset >= sticky) {
        stickbanner.classList.add('sticky-header');
      } else {
        stickbanner.classList.remove('sticky-header');
      }
    },
  },
};
</script>
